export enum DHDiagnosisPlanEvaluationChartFields {
  aestheticProblem = 'aestheticProblem',
  aestheticGoals = 'aestheticGoals',
  aestheticRiskFactor = 'aestheticRiskFactor',
  aestheticMethods = 'aestheticMethods',
  aestheticEvaluation = 'aestheticEvaluation',
  dentalFearProblem = 'dentalFearProblem',
  dentalFearGoals = 'dentalFearGoals',
  dentalFearRiskFactor = 'dentalFearRiskFactor',
  dentalFearMethods = 'dentalFearMethods',
  dentalFearEvaluation = 'dentalFearEvaluation',
  medicalHistoryProblem = 'medicalHistoryProblem',
  medicalHistoryGoals = 'medicalHistoryGoals',
  medicalHistoryRiskFactor = 'medicalHistoryRiskFactor',
  medicalHistoryMethods = 'medicalHistoryMethods',
  medicalHistoryEvaluation = 'medicalHistoryEvaluation',
  oralHygieneProblem = 'oralHygieneProblem',
  oralHygieneGoals = 'oralHygieneGoals',
  oralHygieneRiskFactor = 'oralHygieneRiskFactor',
  oralHygieneMethods = 'oralHygieneMethods',
  oralHygieneEvaluation = 'oralHygieneEvaluation',
  headAndNeckPainProblem = 'headAndNeckPainProblem',
  headAndNeckPainGoals = 'headAndNeckPainGoals',
  headAndNeckPainRiskFactor = 'headAndNeckPainRiskFactor',
  headAndNeckPainMethods = 'headAndNeckPainMethods',
  headAndNeckPainEvaluation = 'headAndNeckPainEvaluation',
  dentalProblem = 'dentalProblem',
  dentalGoals = 'dentalGoals',
  dentalRiskFactor = 'dentalRiskFactor',
  dentalMethods = 'dentalMethods',
  dentalEvaluation = 'dentalEvaluation',
  oralHealthActionProblem = 'oralHealthActionProblem',
  oralHealthActionGoals = 'oralHealthActionGoals',
  oralHealthActionRiskFactor = 'oralHealthActionRiskFactor',
  oralHealthActionMethods = 'oralHealthActionMethods',
  oralHealthActionEvaluation = 'oralHealthActionEvaluation',
  oralHealthKnowledgeProblem = 'oralHealthKnowledgeProblem',
  oralHealthKnowledgeGoals = 'oralHealthKnowledgeGoals',
  oralHealthKnowledgeRiskFactor = 'oralHealthKnowledgeRiskFactor',
  oralHealthKnowledgeMethods = 'oralHealthKnowledgeMethods',
  oralHealthKnowledgeEvaluation = 'oralHealthKnowledgeEvaluation',
}

export const DHDiagnosisPlanEvaluationChartFormDefaultValues = {
  [DHDiagnosisPlanEvaluationChartFields.aestheticProblem]: '',
  [DHDiagnosisPlanEvaluationChartFields.aestheticGoals]: '',
  [DHDiagnosisPlanEvaluationChartFields.aestheticRiskFactor]: '',
  [DHDiagnosisPlanEvaluationChartFields.aestheticMethods]: '',
  [DHDiagnosisPlanEvaluationChartFields.aestheticEvaluation]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalFearProblem]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalFearGoals]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalFearRiskFactor]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalFearMethods]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalFearEvaluation]: '',
  [DHDiagnosisPlanEvaluationChartFields.medicalHistoryProblem]: '',
  [DHDiagnosisPlanEvaluationChartFields.medicalHistoryGoals]: '',
  [DHDiagnosisPlanEvaluationChartFields.medicalHistoryRiskFactor]: '',
  [DHDiagnosisPlanEvaluationChartFields.medicalHistoryMethods]: '',
  [DHDiagnosisPlanEvaluationChartFields.medicalHistoryEvaluation]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHygieneProblem]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHygieneGoals]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHygieneRiskFactor]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHygieneMethods]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHygieneEvaluation]: '',
  [DHDiagnosisPlanEvaluationChartFields.headAndNeckPainProblem]: '',
  [DHDiagnosisPlanEvaluationChartFields.headAndNeckPainGoals]: '',
  [DHDiagnosisPlanEvaluationChartFields.headAndNeckPainRiskFactor]: '',
  [DHDiagnosisPlanEvaluationChartFields.headAndNeckPainMethods]: '',
  [DHDiagnosisPlanEvaluationChartFields.headAndNeckPainEvaluation]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalProblem]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalGoals]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalRiskFactor]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalMethods]: '',
  [DHDiagnosisPlanEvaluationChartFields.dentalEvaluation]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthActionProblem]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthActionGoals]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthActionRiskFactor]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthActionMethods]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthActionEvaluation]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthKnowledgeProblem]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthKnowledgeGoals]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthKnowledgeRiskFactor]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthKnowledgeMethods]: '',
  [DHDiagnosisPlanEvaluationChartFields.oralHealthKnowledgeEvaluation]: '',
};
